"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/list/style/css");

var _list = _interopRequireDefault(require("antd/es/list"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

require("./newQnaPostForm.scss");

var _QnaComment = _interopRequireDefault(require("./QnaComment"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class QnaCommentList extends _react.Component {
  constructor() {
    super(...arguments);

    this.renderDate = value => {
      if (!value) {
        return 'N/a';
      }

      return (0, _moment.default)(value).calendar();
    };
  }

  render() {
    const {
      level,
      comments
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_list.default, {
      className: "qna-comment-list",
      itemLayout: "vertical",
      dataSource: comments,
      locale: {
        emptyText: 'No Comments'
      },
      renderItem: item => /*#__PURE__*/_react.default.createElement(_QnaComment.default, {
        comment: item,
        level: level
      })
    });
  }

}

var _default = QnaCommentList;
exports.default = _default;